import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from '../services/local-storage.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  constructor(private localStorage: LocalStorageService) { }

  ngOnInit(): void {
  }

  schoolDisplayName(): string {
    return this.localStorage.getSchoolDisplayName() || environment.schoolName;
  }

  isAdmin(): boolean {
    return this.localStorage.isAdmin();
  }

  isTeacher(): boolean {
    return this.localStorage.isTeacher();
  }

}
